function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState, useEffect, forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { fontStyle, spacing, borderRadius, themeLight } from '@naf/theme';
import { propValidationConfig } from '../propValidationConfig';
export const Input = /*#__PURE__*/forwardRef(({
  as = 'input',
  value = '',
  maxCharacters,
  onChange,
  error = false,
  placeholder,
  disabled = false,
  ariaLabel,
  width = 256,
  className,
  ...rest
}, ref) => {
  const [count, setCount] = useState(0);
  const [text, setText] = useState(value);
  const handleChange = e => {
    if (!onChange) return;
    if (maxCharacters && e.target.value.length <= maxCharacters) {
      setCount(e.target.value.length);
      setText(e.target.value);
      onChange(e.target.value);
    }
    if (!maxCharacters) {
      setText(e.target.value);
      onChange(e.target.value);
    }
  };
  useEffect(() => {
    if (maxCharacters && value.length <= maxCharacters) {
      setCount(value.length);
      setText(value);
    }
    if (maxCharacters && value.length > maxCharacters) {
      setText(value.slice(0, maxCharacters));
      setCount(value.slice(0, maxCharacters).length);
    }
    if (!maxCharacters) {
      setText(value);
    }
  }, [value, maxCharacters]);
  return /*#__PURE__*/React.createElement(Container, {
    className: className,
    width: width
  }, /*#__PURE__*/React.createElement(StyledInput, _extends({
    as: as,
    value: text,
    placeholder: placeholder,
    error: error,
    disabled: disabled,
    onChange: handleChange,
    "aria-label": ariaLabel,
    ref: ref
  }, rest)), maxCharacters && /*#__PURE__*/React.createElement(Count, null, count, "/", maxCharacters, " tegn"));
});
export default Input;
const errorStyle = css(["border:2px solid ", ";padding:calc(", " - 1px);"], ({
  theme
}) => theme.componentColors ? theme.componentColors.alert.error : themeLight.componentColors.alert.error, spacing.space8);
const Container = styled.div.withConfig(propValidationConfig).withConfig({
  displayName: "input__Container",
  componentId: "sc-1s9woh7-0"
})(["display:flex;flex-direction:column;position:relative;width:", "px;"], props => props.width);
const StyledInput = styled.input.withConfig(propValidationConfig).withConfig({
  displayName: "input__StyledInput",
  componentId: "sc-1s9woh7-1"
})(["background:", ";border:1px solid ", ";box-sizing:border-box;border-radius:", ";padding:", ";", ";outline:0;font-variant-numeric:lining-nums !important;&:disabled{background-color:", ";border-color:", ";color:", ";-webkit-text-fill-color:", ";cursor:not-allowed;opacity:1;}&:focus{border-color:", ";}", " ", " ::placeholder{color:", ";}", " ", " &:invalid{", ";}"], ({
  theme
}) => theme.background ? theme.background.default : themeLight.background.default, ({
  theme
}) => theme.border ? theme.border.heavy : themeLight.border.heavy, borderRadius.M, spacing.space8, fontStyle.article.articleText, ({
  theme
}) => theme.componentColors ? theme.componentColors.inputElement.backgroundDisabled : themeLight.componentColors.inputElement.backgroundDisabled, ({
  theme
}) => theme.border ? theme.border.heavy : themeLight.border.heavy, ({
  theme
}) => theme.typography ? theme.typography.disabledText : themeLight.typography.disabledText, ({
  theme
}) => theme.typography ? theme.typography.disabledText : themeLight.typography.disabledText, ({
  theme
}) => theme.typography ? theme.typography.defaultText : themeLight.typography.defaultText, ({
  as
}) => as === 'textarea' && css(["min-height:", ";"], spacing.space160), ({
  as
}) => as === 'input' && css(["height:", ";"], spacing.space48), ({
  theme
}) => theme.typography ? theme.typography.subtleText : themeLight.typography.subtleText, ({
  disabled
}) => disabled && css(["background-color:", ";border-color:", ";color:", ";-webkit-text-fill-color:", ";cursor:not-allowed;opacity:1;"], ({
  theme
}) => theme.componentColors ? theme.componentColors.inputElement.backgroundDisabled : themeLight.componentColors.inputElement.backgroundDisabled, ({
  theme
}) => theme.border ? theme.border.heavy : themeLight.border.heavy, ({
  theme
}) => theme.typography ? theme.typography.disabledText : themeLight.typography.disabledText, ({
  theme
}) => theme.typography ? theme.typography.disabledText : themeLight.typography.disabledText), ({
  error
}) => error && css(["", ";"], errorStyle), errorStyle);
const Count = styled.span.withConfig({
  displayName: "input__Count",
  componentId: "sc-1s9woh7-2"
})(["", ";display:flex;align-self:flex-end;bottom:calc( -", " * ", " - ", " );color:", ";"], fontStyle.bodyText.small, fontStyle.bodyText.small['font-size'], fontStyle.bodyText.small['line-height'], spacing.space8, ({
  theme
}) => theme.typography ? theme.typography.subtleText : themeLight.typography.subtleText);
//# sourceMappingURL=input.js.map